<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('advance_payment')">
        </app-page-top-section>

        <app-table
            id="finance-advance-payment-table"
            :options="options"
            @action="triggerActions"
        />

        <app-finance-advance-payment-status-modal
            v-if="isStatusModalActive"
            v-model="isStatusModalActive"
            :payment-id="selectedPayment.id"
            :current-status="selectedPayment.status"
        />

        <app-confirmation-modal
            v-if="confirmationModalActive"
            icon="trash-2"
            modal-id="app-confirmation-modal"
            @confirmed="confirmed('finance-advance-payment-table')"
            @cancelled="cancelled"
        />
    </div>
</template>

<script>
import HelperMixin from "../../../../common/Mixin/Global/HelperMixin";
import FinanceAdvancePaymentMixin from "../../Mixins/FinanceAdvancePaymentMixin";

export default {
    name  : "FinanceAdvancePayment",
    mixins: [HelperMixin, FinanceAdvancePaymentMixin],
    data() {
        return {
            selectedPayment: null,
            isStatusModalActive: false,
        }
    },
    methods: {
        triggerActions(row, action) {
            if (action.name === 'edit') {
                this.selectedPayment = row;
                this.isStatusModalActive = true;
            } else if (action.title === this.$t('delete')) {
                this.getAction(row, action, true);
            } else {
                this.getAction(row, action, true);
            }
        },
    }
}
</script>
